import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateSubmittedV1DataSchema } from "./estimate-review-shared";

const InsuranceRevisionEstimateSubmittedDataSchema = z.discriminatedUnion("version", [EstimateSubmittedV1DataSchema]);

export const InsuranceRevisionEstimateSubmittedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_REVISION_ESTIMATE_SUBMITTED),
  data: InsuranceRevisionEstimateSubmittedDataSchema,
});
